'use client';

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GlobalCorporation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="global_corporation">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="content_wrapper mb-4">
              <h2>
                {t('global_heading_line1')} <br />
                {t('global_heading_line2')}
              </h2>
            </div>

            <div className="three_black_box d-flex flex-column flex-md-row justify-content-center gap-3">
              <div className="black_three text-center">
                <a
                  href="tel:+971585703027"
                  target="_self"
                  rel="noopener noreferrer"
                >
                  +971-585703027
                </a>
              </div>

              <div className="black_three text-center">
                <Link to="/appointment">{t('book_consultation')}</Link>
              </div>
              <div className="black_three text-center">
                <Link to="/contact-us">{t('make_inquiry')}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalCorporation;
